// 📁 store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { createFunctionalSetter } from '../storeCommons';
import { Item, JournalCodeMapping, JournalCodesMapping, PointDeSuspens } from '../../types';
import { PointsSuspensInitialState, PointsSuspensState } from './pointsSuspensInitialState';

/**
 * @french
 * Interface des actions liées à l'import FEC (balance).
 */
export interface PointsSuspensActions {
  setFileId: (fileId: string) => void;
  setLoading: (loading: boolean) => void;
  setSelectedItem: (item: Item | null) => void;
  setUnmappedAccounts: (accounts: PointDeSuspens[]) => void;
  setSelectedIds: (selectedIds: string[]) => void;
  setEnabled: (enabled: boolean) => void;
  setFetchNew: (fetchNew: boolean) => void;
  setSirenFec: (sirenFec: string) => void;
  setDateFec: (dateFec: Date | undefined) => void;
  setFileName: (fileName: string | undefined) => void;
  setJournalCodeMappingRequests: (
    updater: JournalCodeMapping[] | ((prev: JournalCodeMapping[]) => JournalCodeMapping[]),
  ) => void;
  setJournalCodesMapping: (
    updater:
      | JournalCodesMapping
      | ((prev: JournalCodesMapping | null) => JournalCodesMapping | null)
      | null,
  ) => void;
  setIsGenerationPopupOpen: (isGenerationPopupOpen: boolean) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour gérer l'état et les actions liés à la balance FEC.
 */
export const createPointsSuspensSlice: StateCreator<
  PointsSuspensState & PointsSuspensActions,
  [],
  [],
  PointsSuspensActions
> = (set, get) => ({
  setFileId: (fileId) => set({ fileId }),
  setLoading: (loading) => set({ loading }),
  setSelectedItem: (item) => set({ selectedItem: item }),
  setUnmappedAccounts: (accounts) => set({ unmappedAccounts: accounts }),
  setSelectedIds: (selectedIds) => set({ selectedIds }),
  setEnabled: (enabled) => set({ enabled }),
  setFetchNew: (fetchNew) => set({ fetchNew }),
  setSirenFec: (sirenFec) => set({ sirenFec }),
  setDateFec: (dateFec) => set({ dateFec }),
  setFileName: (fileName) => set({ fileName }),
  setJournalCodeMappingRequests: createFunctionalSetter(get, set, 'journalCodeMappingRequests'),
  setJournalCodesMapping: createFunctionalSetter(get, set, 'journalCodesMapping'),
  setIsGenerationPopupOpen: (isGenerationPopupOpen) => set({ isGenerationPopupOpen }),
  reset: () => set(PointsSuspensInitialState),
});
